module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'op--modal-container': true, hide: !_vm.show
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "driver-notes small-margin-v-s",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.driverNotes')))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addNote($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    staticClass: "field-text",
    attrs: {
      "placeholder": _vm.$t('rsvpEdit.typeNote')
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'error-message margin-b-s': true, hide: !_vm.error.show
    }
  }, [_vm._v(_vm._s(_vm.error.message))]), _vm._v(" "), _c('button', {
    staticClass: "op-btn btn-block btn-success btn-lg"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.saveNote')))]), _vm._v(" "), _c('a', {
    staticClass: "remove-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.removeNote
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.removeNote')))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f2804080", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2804080","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/DriverNotes.vue
// module id = 2152
// module chunks = 0